export default function shouldRenderHeader(pathname) {
    const controlRoutes = new Set([]);

    return !controlRoutes.has(pathname);
}
